import Skeleton from '@mui/material/Skeleton';

import { SummaryCardProps } from './types';
import { Container } from './styles';

export function SummaryCard({
  value,
  label,
  icon,
  color,
  loading,
}: SummaryCardProps) {

  return (
    <Container elevation={3} color={color}>
      {icon && <div className="icon-container">{icon}</div>}

      {(typeof value !== 'undefined' && !loading)
        ? <strong>{value}</strong>
        : <Skeleton variant="text" width={60} height={27} />
      }

      <p>{label}</p>
    </Container>
  )
}
